module.exports = __webpack_public_path__ + "img/24.aff15dad.png";